import axios from "axios";
import getEndpoint from "../getEndpoint";

const ngrokSkipWarning = { headers: { "bypass-tunnel-reminder": "true" } };

export async function GetAllOrderProducts() {
    const response = await axios.get(`${getEndpoint()}/api/OrderProduct/GetAll`, ngrokSkipWarning);
    return response.data;
}

export async function GetAllOrderProductsByOrderId(orderId:any) {
    const response = await axios.get(`${getEndpoint()}/api/OrderProduct/GetAllByOrderId?id=${orderId}`, ngrokSkipWarning);
    return response.data;
}

export async function GetOrderProduct(id:any) {
    const response = await axios.get(`${getEndpoint()}/api/OrderProduct/Get?id=${id}`, ngrokSkipWarning);
    return response.data;
}

export async function AddOrderProduct(orderProductDTO:any) {
    const response = await axios.post(`${getEndpoint()}/api/OrderProduct/Add`, orderProductDTO, ngrokSkipWarning);
    return response.data;
}

export async function UpdateOrderProduct(orderProductDTO:any) {
    const response = await axios.put(`${getEndpoint()}/api/OrderProduct/Update`, orderProductDTO, ngrokSkipWarning);
    return response.data;
}

export async function DeleteOrderProduct(id:any) {
    const response = await axios.delete(`${getEndpoint()}/api/OrderProduct/Delete?id=${id}`, {
        ...ngrokSkipWarning
    });
    return response.data;
}
